export default __webpack_public_path__ + "static/media/Prithvi.595b858a.jpg";